<template>
  <div>
    <el-form ref="form" :model="form" label-width="180px">
      <el-row>
        <el-col :span="24">
          <el-form-item label="上传证件">
            <ImgUpload
              :required="false"
              :upload-config="{
                lebal: '身份证人像面照片',
                prefix: 'identification',
                form: form,
                suffix: 'Img'
              }"
              :parent-data="parentData"
            />
            <ImgUpload
              :required="false"
              :upload-config="{
                lebal: '身份证国徽面照片',
                prefix: 'identificationBack',
                form: form,
                suffix: 'Img'
              }"
              :parent-data="parentData"
            />
            <ImgUpload
              :required="false"
              :upload-config="{
                lebal: '实际承运人半身照',
                prefix: 'driver',
                form: form,
                suffix: 'Img'
              }"
              :parent-data="parentData"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="备注">
            <el-input v-model="form.verifyRemark" type="textarea" disabled />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import ImgUpload from "@/components/ImgUpload";
import Vue from "vue";
import request from "@/utils/request";
import { insuranceType } from "@/api/orderform";
export default {
  name: "DriverEdit",
  components: {
    ImgUpload
  },
  props: {
    parentData: {
      type: Object,
      default() {
        return {
          isDetail: true
        };
      }
    }
  },
  data() {
    return {
      hasTaxOpen: "",
      showExtra: true,
      otherItems: true,
      linkageInvalid: true,
      submitShow: true,
      form: {
        partyCode: "",
        verifyRemark: "",
        authStatus: ""
      },
      // 挂车
      isHasTrailerOptions: [
        { label: "无", value: 0 },
        { label: "有", value: 1 }
      ],
      // 挂靠车辆
      isLinkedOptions: [{ label: "否", value: 0 }, { label: "是", value: 1 }],
      // 是否清分
      isShareOptions: [{ label: "否", value: 0 }, { label: "是", value: 1 }]
    };
  },
  methods: {
    // 区域切换
    changeAreaList(value) {
      if (value.length > 0) {
        this.form.provinceCode = value[0];
        this.form.cityCode = value[1];
        this.form.countyCode = value[2];
      } else {
        this.form.provinceCode = "";
        this.form.cityCode = "";
        this.form.countyCode = "";
      }
    },
    getDriver(code) {
      this.code = code;
      request({
        url: `/ntocc-basic-api/driver/${code}`,
        method: "get"
      }).then(response => {
        this.form = response.data;
        this.form.vehicleVO = this.form.vehicleVO ? this.form.vehicleVO : {};
        Vue.set(this.form, "areaList", []);
        if (
          this.form.provinceCode &&
          this.form.cityCode &&
          this.form.countyCode
        ) {
          this.form.areaList.push(
            this.form.provinceCode,
            this.form.cityCode,
            this.form.countyCode
          );
        }
        this.$set(
          this.form,
          "hasDueDate",
          this.form.idCardDueDate == "9999-12-31"
        );
        this.$set(
          this.form,
          "hasDriverDueDate",
          this.form.driverLicenseDueDate == "9999-12-31"
        );
        insuranceType(this.instype).then(response => {
          this.locationSourceoptions = response.data.records;
        });
      });
    },
    // 同意审核
    funcSubmit() {
      const rLoading = this.openLoading();
      request({
        url: `/ntocc-basic-api/driver/updateTaxAuth`,
        method: "post",
        params: {
          partyCode: this.form.partyCode,
          verifyRemark: this.form.verifyRemark,
          authStatus: 1
        }
      }).then(response => {
        rLoading.close();
        this.$message({
          message: response.msg,
          type: "success"
        });
        this.$emit("fatherMethods");
      });
    },
    // 拒绝审核
    funcRefuse() {
      const rLoading = this.openLoading();
      request({
        url: `/ntocc-basic-api/driver/updateTaxAuth`,
        method: "post",
        params: {
          partyCode: this.form.partyCode,
          verifyRemark: this.form.verifyRemark,
          authStatus: 2
        }
      }).then(response => {
        rLoading.close();
        this.$message({
          message: response.msg,
          type: "success"
        });
        this.$emit("fatherMethods");
      });
    }
  }
};
</script>
<style lang="scss" scoped>
._btns {
  display: flex;
  align-items: center;
  justify-content: center;
}
.el-cascader {
  width: 100%;
}
.el-select {
  width: 100%;
}
.el-date-editor {
  width: 100%;
}
.el-form {
  width: 80%;
  margin: 0 auto;
}
</style>
